import React, { useEffect, useMemo } from 'react';
import StackedVerticalBarChart from '../../../../ui/StackedVerticalBarChart';
import useFetchData from '../../../../hooks/useFetchData';
import { getProjectStatistics } from '../../../../apis/impact-report/report';
import Loader from '../../../../ui/Loader';
import { useFilters } from '../../../../contexts/FiltersContext';
import { useSearchParams } from 'react-router-dom';
import { colourList } from '../../../../constants/datas';

const ActivityTypesTab = ({projectId,imageGenerationTimestamp}) => {
    const { selectedPrimary, setFilterOptions } = useFilters()
    const { loading, response, error } = useFetchData(
        getProjectStatistics,
        [projectId,"BOUNTY_TYPE_WISE_SUBMISSION_COUNT",imageGenerationTimestamp,""],
        [projectId,"BOUNTY_TYPE_WISE_SUBMISSION_COUNT",imageGenerationTimestamp,""]
    );

    useEffect(()=>{
        if (!loading && response) {
            const monthly = response?.bountyTypeWiseSubmissionCount || []
            const list = Array.from(new Set(
                (monthly || [])
                    .flatMap(m => (m?.distribution || []).map(d => d?.bountyType))
                    .filter(Boolean)
            ))

            setFilterOptions({ label: 'Activity Types', options: list })
        }
    },[loading, response, setFilterOptions])

    // Build activity types list from response
    const allActivityTypes = useMemo(() => {
        const monthly = response?.bountyTypeWiseSubmissionCount || []
        return Array.from(new Set(
            (monthly || [])
                .flatMap(m => (m?.distribution || []).map(d => d?.bountyType))
                .filter(Boolean)
        ))
    }, [response])

    const allSelected = !selectedPrimary?.length || selectedPrimary.includes('All')
    const filteredActivityTypes = allSelected ? allActivityTypes : allActivityTypes.filter(t => selectedPrimary.includes(t))

    // Transform API data to chart data: one entry per month, keys for each activity type
    // const chartData = useMemo(() => {
    //     const monthly = response?.bountyTypeWiseSubmissionCount || []
    //     return monthly.map(m => {
    //         // Format month labels as short month names (Jan, Feb, Mar, etc.)
    //         const formatMonthLabel = (monthStr) => {
    //             if (!monthStr) return monthStr;
                
    //             // Handle different possible month formats
    //             let date;
    //             if (monthStr.includes('-')) {
    //                 // Format: "2024-01" or "2024-1"
    //                 const [year, month] = monthStr.split('-');
    //                 date = new Date(parseInt(year), parseInt(month) - 1, 1);
    //             } else if (monthStr.length === 6) {
    //                 // Format: "202401"
    //                 const year = monthStr.substring(0, 4);
    //                 const month = monthStr.substring(4, 6);
    //                 date = new Date(parseInt(year), parseInt(month) - 1, 1);
    //             } else {
    //                 // Try to parse as is
    //                 date = new Date(monthStr);
    //             }
                
    //             if (isNaN(date.getTime())) {
    //                 return monthStr; // Return original if parsing fails
    //             }
                
    //             // Return short month name (Jan, Feb, Mar, etc.)
    //             return date.toLocaleDateString('en-US', { month: 'short' });
    //         };

    //         const row = { name: formatMonthLabel(m?.month) }
    //         // initialize selected types to 0 so stacks align
    //         filteredActivityTypes.forEach(type => { row[type] = 0 })
    //         ;(m?.distribution || []).forEach(d => {
    //             if (filteredActivityTypes.includes(d?.bountyType)) {
    //                 row[d.bountyType] = d?.submissionCount || 0
    //             }
    //         })
    //         return row
    //     })
    // }, [response, filteredActivityTypes])
const chartData = useMemo(() => {
    const monthly = response?.bountyTypeWiseSubmissionCount || []
    return monthly.map(m => {
        // Format month labels as "Mon YYYY" (Jan 2024, Feb 2024, etc.)
        const formatMonthLabel = (monthStr) => {
            if (!monthStr) return monthStr;
            
            // Handle different possible month formats
            let date;
            if (monthStr.includes('-')) {
                // Format: "2024-01" or "2024-1"
                const [year, month] = monthStr.split('-');
                date = new Date(parseInt(year), parseInt(month) - 1, 1);
            } else if (monthStr.length === 6) {
                // Format: "202401"
                const year = monthStr.substring(0, 4);
                const month = monthStr.substring(4, 6);
                date = new Date(parseInt(year), parseInt(month) - 1, 1);
            } else {
                // Try to parse as is
                date = new Date(monthStr);
            }
            
            if (isNaN(date.getTime())) {
                return monthStr; // Return original if parsing fails
            }
            
            // Return month and year (Jan 2024, Feb 2024, etc.)
            return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
        };

        const row = { name: formatMonthLabel(m?.month) }
        // initialize selected types to 0 so stacks align
        filteredActivityTypes.forEach(type => { row[type] = 0 })
        ;(m?.distribution || []).forEach(d => {
            if (filteredActivityTypes.includes(d?.bountyType)) {
                row[d.bountyType] = d?.submissionCount || 0
            }
        })
        return row
    })
}, [response, filteredActivityTypes])


    // Get the year from the data for the x-axis label
    const getYearFromData = () => {
        const monthly = response?.bountyTypeWiseSubmissionCount || []
        if (monthly.length === 0) return new Date().getFullYear();
        
        const firstMonth = monthly[0]?.month;
        if (!firstMonth) return new Date().getFullYear();
        
        // Extract year from different possible formats
        if (firstMonth.includes('-')) {
            return firstMonth.split('-')[0];
        } else if (firstMonth.length === 6) {
            return firstMonth.substring(0, 4);
        } else {
            return new Date(firstMonth).getFullYear() || new Date().getFullYear();
        }
    };

    const currentYear = getYearFromData();

    if (loading) return <div className='w-full h-[23.9375rem] flex pt-11 justify-center'><Loader/></div>;
    if ((chartData || []).length === 0) return <div className="w-full h-[23.9375rem] flex items-center justify-center text-gray-500">No data available</div>;
console.log(response?.bountyTypeWiseSubmissionCount,"these are submission type charts data",chartData)
    return (
        <StackedVerticalBarChart 
            data={chartData}
            stackKeys={filteredActivityTypes}
            xAxisLabel={`Timelines`}
            yAxisLabel="No. of submissions"
            colors={colourList}
            barSize={40}
            height={500}
            visibleBars={17}
            showLegend={true}
        />
    );
};

export default ActivityTypesTab; 

